import React from 'react';
import {Button, Col, Container, Row} from 'react-bootstrap';
import {Link, useParams} from 'react-router-dom';

import {convertCasing, casings} from '@nick-bull/convert-casing';

import {Card} from '#components/card';
import {Header} from '#components/header';

import {articleService} from '#services/articleService';

import '#root/common.css';
import '#pages/home.css';

const articles = articleService.getArticles();
const articleEntries = Object.entries(articles);

export const Projects = () => {
  const articleCards = articleEntries.map(([key, article]) => {
    const {media = [], rationale, thumbnail} = article;

    const title = convertCasing(key, casings.camel, casings.proper);
    const slug = convertCasing(key, casings.camel, casings.kebab);

    return (
      <Card
        as={Link}
        to={`/projects/${slug}`}
        md={6}
        key={key}
        title={title}
        subtitle={rationale}
        coverImagePath={thumbnail}
      />
    );
  });

  return (
    <Container className="home" fluid>
      <Header title="Recent projects" />

      <Container className="articles--body-wrapper">
        <Row className="articles-features">
          {articleCards}
        </Row>
      </Container>
    </Container>
  );
};

